import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

const qs = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

export const getEligibleSchedulesForMarksPortal = async (filters = {}) => {
  const res = await axiosInstance.get(`/marks-portal/eligible${qs(filters)}`);
  return res.data;
};

export const getTeachersForSchedulePortal = async (scheduleId, filters = {}) => {
  const res = await axiosInstance.get(
    `/marks-portal/teachers-for-schedule/${scheduleId}${qs(filters)}`
  );
  return res.data;
};

export const createMarksAssignmentPortal = async (data) => {
  const res = await axiosInstance.post("/marks-portal/assign", data);
  return res.data;
};

export const getAllMarksAssignmentsPortal = async (filters = {}) => {
  const res = await axiosInstance.get(
    `/marks-portal/assignments/all${qs(filters)}`
  );
  return res.data;
};

export const updateMarksAssignmentStatusPortal = async (id, data) => {
  const res = await axiosInstance.put(
    `/marks-portal/assignments/status/${id}`,
    data
  );
  return res.data;
};

export const getMyMarksAssignments = async (filters = {}) => {
  const res = await axiosInstance.get(
    `/marks-portal/my-assignments${qs(filters)}`
  );
  return res.data;
};

export const getStudentsForMarksEntry = async (assignmentId) => {
  const res = await axiosInstance.get(`/marks-portal/entry/${assignmentId}`);
  return res.data;
};

export const saveMarksEntry = async (data) => {
  const res = await axiosInstance.post("/marks-portal/entry/save", data);
  return res.data;
};

export const submitMarksEntry = async (assignmentId) => {
  const res = await axiosInstance.post(
    `/marks-portal/entry/submit/${assignmentId}`
  );
  return res.data;
};

export const getMarksForSectionPortal = async (filters = {}) => {
  const res = await axiosInstance.get(`/marks-portal/section${qs(filters)}`);
  return res.data;
};
